<template>
  <div class="placeholder-tool-page">
    <v-container class="py-10">
      <v-card outlined class="pa-8">
        <div class="text-overline grey--text text--darken-1 mb-3">Tools</div>
        <h1 class="text-h4 mb-3">{{ title }}</h1>
        <p class="text-body-1 mb-0">
          This tool is a placeholder for now. The shell is in place so we can wire the real experience in cleanly later.
        </p>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderTool',
  computed: {
    title() {
      return this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : 'Tool Placeholder'
    }
  }
}
</script>

<style scoped>
.placeholder-tool-page {
  min-height: calc(100vh - 64px);
  background: #ffffff;
}
</style>
